import { ScheduledMatch, TeamModel } from 'types/Schedule.types';

export const sortNflTeamModelsByTeamId = (a: TeamModel, b: TeamModel) => {
  return parseInt(a.teamID) - parseInt(b.teamID);
};

export const sortScheduledMatchesByStartingDate = (a: ScheduledMatch, b: ScheduledMatch) => {
  return new Date(a.startingDate).getTime() - new Date(b.startingDate).getTime();
};
